// extracted by mini-css-extract-plugin
export default {"root":"_Ftb6Ei4dDrNg5cxT7Ni","logo":"S4S3gsYzwlvqr2nTidJg","p":"t3B2kU0FzU89cfqrexGm","small":"dPeMMMdts5YMIjZEAPUK","placeHolderShimmer":"qUjvbwvBF2OoTeCxRBaa"};